import React, { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import InterviewLayout from "@/layouts/Interview";
import RouterErrorBoundary from "@/errors/RouterErrorBoundary/RouterErrorBoundary";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

// Common/Entry Pages ==================
const InterviewHome = lazy(() => import("@/features/interview/pages/comman/InterviewHome"));
const EntryChecklist = lazy(() => import("@/features/interview/pages/comman/EntryChecklist"));

// Status & Feedback ==================
const WaitingRoom = lazy(() => import("@/features/interview/pages/comman/WaitingRoom"));
const SuccessScreen = lazy(() => import("@/features/interview/pages/comman/SuccessScreen"));
const DeclineScreen = lazy(() => import("@/features/interview/pages/comman/DeclineScreen"));
const ScheduleScreen = lazy(() => import("@/features/interview/pages/comman/ScheduleScreen"));

// Video Interview Flow ==================
const VideoContainer = lazy(() => import("@/features/interview/pages/videoInterview/VideoContainer"));
const VideoSession = lazy(() => import("@/features/interview/pages/videoInterview/VideoSession"));
const VideoInstructions = lazy(() => import("@/features/interview/pages/videoInterview/VideoInstructions"));
const VideoConnectivity = lazy(() => import("@/features/interview/pages/videoInterview/VideoConnectivity"));
const VideoSpeedTest = lazy(() => import("@/features/interview/pages/videoInterview/VideoSpeedTest"));

// Other Formats ==================
const TextInterview = lazy(() => import("@/features/interview/pages/textInterview/TextInterview"));
const FormInterview = lazy(() => import("@/features/interview/pages/formInterview/FormInterview"));

// Personal/Live Interview ==================
const PersonalContainer = lazy(() => import("@/features/interview/pages/personalInterview/PersonalContainer"));
const LiveVideoRoom = lazy(() => import("@/features/interview/pages/personalInterview/LiveVideoRoom"));
const RoomExit = lazy(() => import("@/features/interview/pages/personalInterview/RoomExit"));
const RoomSettings = lazy(() => import("@/features/interview/pages/personalInterview/RoomSettings"));

// Standardized Wrapper
const InterviewLayoutWrapper = () => (
  <InterviewLayout>
    <Suspense fallback={<LoadingFeedback />}>
      <Outlet />
    </Suspense>
  </InterviewLayout>
);

export const interviewRoutes = [
  {
    path: "/interview",
    element: <InterviewLayoutWrapper />,
    errorElement: <RouterErrorBoundary />,
    children: [
      { index: true, element: <InterviewHome /> },
      { path: "pre-check", element: <EntryChecklist /> },
      
      // Status & Scheduling
      { path: "waiting-room", element: <WaitingRoom /> },
      { path: "success", element: <SuccessScreen /> },
      { path: "declined", element: <DeclineScreen /> },
      { path: "schedule", element: <ScheduleScreen /> },

      //  Video Interview Flow
      {
        path: "video",
        element: 
        <VideoContainer />,
        children: [
          { index: true, element: <VideoSession /> },
          { path: "instructions", element: <VideoInstructions /> },
          { path: "hardware-check", element: <VideoConnectivity /> },
          { path: "speed-test", element: <VideoSpeedTest /> },
        ],
      },

      // Other Formats
      { path: "text", element: <TextInterview /> },
      { path: "form", element: <FormInterview /> },

      // Live Personal Interview Flow
      {
        path: "personal/:interviewId/:apiKeyInterview",
        element: <PersonalContainer />,
        children: [
          { index: true, element: <LiveVideoRoom /> },
          { path: "room-exit", element: <RoomExit /> },
          { path: "settings", element: <RoomSettings /> },
        ],
      },
    ],
  },
];